import { __rest } from "tslib";
import * as React from "react";
import { forwardRef } from "react";
import clsx from 'clsx';
const _RuleIcon = (_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return React.createElement("svg", Object.assign({ fill: "currentColor", viewBox: "0 0 24 24", role: "presentation", width: 16, height: 16, className: clsx("cmp-icon", className), ref: ref }, props),
        React.createElement("path", { d: "M5.5 14.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Zm13-5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Zm0 10a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z" }),
        React.createElement("path", { d: "M7 11h4v2H7v-2Zm6 5h4v2h-4v-2Zm0-10h4v2h-4V6Zm-2 0h2v12h-2V6Z" }));
};
const RuleIcon = forwardRef(_RuleIcon);
export default RuleIcon;
//# sourceMappingURL=rule.js.map